var detectUserLanguage = function detectUserLanguage(supportedLanguages) {
  if (typeof window !== 'undefined') {
    var userLanguage = (navigator.language || navigator.userLanguage).split('-')[0];
    return supportedLanguages.includes(userLanguage) ? userLanguage : 'en';
  }
  return 'en';
};
module.exports = {
  detectUserLanguage: detectUserLanguage
};